import { Show } from '@bygghemmait/components';
import { IconChartUp, IconEye, IconWatch } from 'components/Shared/Icon';
import { IconThumbsUp } from 'components/Shared/Icon/iconThumbsUp';
import { Toast } from 'components/Toast';
import { DisplayType } from 'models/AlertNotification';
import { EnticementType } from 'models/EnticementType';
import { useSelector } from 'react-redux';
import { getEnticement } from 'views/ProductPage/selector';
import styles from './styles.scss';

const enticementIconsMap = {
  [EnticementType.None]: null,
  [EnticementType.Popular]: <IconEye size="medium" />,
  [EnticementType.BestSelling]: <IconThumbsUp size="medium" />,
  [EnticementType.Trending]: <IconChartUp size="medium" />,
  [EnticementType.LimitedOffer]: <IconWatch size="medium" />
};

export const Enticement = () => {
  const enticement = useSelector(getEnticement);
  return (
    <Show when={enticement}>
      {enticement => (
        <Toast className={styles.enticement} type={DisplayType.Information}>
          <Show when={enticement.type}>{type => enticementIconsMap[type]}</Show>
          <span>{enticement.title}</span>
        </Toast>
      )}
    </Show>
  );
};
